import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { SupportTicketInfo } from '../support-ticket-info';
import { tap, withLatestFrom } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { SupportDetailsService } from '../support-details.service';
import { SupportTicketDialogComponent } from '../support-ticket-dialog.component';
import { Ticket } from '../support_sdk/_internal';
import { TrimDescriptionPipe } from '../support-ticket.pipe';
import { take } from 'rxjs';

@Component({
  selector: 'app-support-ticket-card',
  imports: [
    CommonModule,
    GalaxyPipesModule,
    MatCardModule,
    MatIconModule,
    TranslateModule,
    GalaxyBadgeModule,
    MatButtonModule,
    TrimDescriptionPipe,
  ],
  templateUrl: './support-ticket-card.component.html',
  styleUrls: ['../../association-panel-base-styles.component.scss', './support-ticket-card.component.scss'],
})
export class SupportTicketCardComponent {
  tickets: Ticket[] = [];
  protected ticketInfo: SupportTicketInfo;
  protected isMinView = true;

  @Input() set ticketCardInfo(ticket: SupportTicketInfo) {
    this.ticketInfo = ticket;
  }

  private readonly dialog = inject(MatDialog);
  private readonly alertService = inject(SnackbarService);
  private readonly supportService = inject(SupportDetailsService);

  showMoreLess() {
    this.isMinView = !this.isMinView;
  }

  viewTicketComments(ticket: Ticket): void {
    this.supportService
      .loadTicketComments(ticket.id)
      .pipe(
        withLatestFrom(this.supportService.users$),
        tap(([resp, users]) => {
          this.dialog.open(SupportTicketDialogComponent, {
            data: {
              ticket: ticket,
              ticketComments: resp,
              users: users,
            },
          });
        }),
        take(1),
      )
      .subscribe(null, () => {
        this.alertService.openErrorSnack('Failed to load ticket comments.');
      });
  }
}
